// extracted by mini-css-extract-plugin
export var dataCell = "_m6-2";
export var dataRow = "_m6-0";
export var headerRow = "_m6-1";